function AboutModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center px-4"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
      onClick={onClose}
    >
      <div
        className="bg-bg-primary border border-border max-w-md w-full p-8 relative"
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: "#070707" }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 font-space text-[20px] transition-colors duration-200"
          style={{ color: "#888888" }}
          onMouseEnter={(e) => (e.target.style.color = "#FF6B00")}
          onMouseLeave={(e) => (e.target.style.color = "#888888")}
        >
          x
        </button>

        {/* Title */}
        <h2
          className="font-space text-[28px] mb-6 text-center"
          style={{
            color: "#FF6B00",
            fontWeight: "700",
          }}
        >
          About Pixrd
        </h2>

        {/* Content */}
        <div className="space-y-4 text-center">
          <p
            className="font-space text-[16px] leading-relaxed"
            style={{
              color: "#b0b0b0",
              fontWeight: "500",
            }}
          >
            We're building the operating system (CreatorOS) for modern creators.
          </p>

          <p
            className="font-space text-[16px] leading-relaxed"
            style={{
              color: "#b0b0b0",
              fontWeight: "500",
            }}
          >
            Starting with AI video editing, expanding to social automation,
            analytics, and more.
          </p>

          <p
            className="font-space text-[16px] leading-relaxed"
            style={{
              color: "#b0b0b0",
              fontWeight: "500",
            }}
          >
            Built by creators, for creators.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutModal;
